import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { useAuthStore } from '@/stores/auth-store';

import { LandingPaidPlans } from './landing-paid-plans';
import { LandingMarketingShell, LandingReveal, LandingSection } from './landing-shared';
import './landing.css';

export const PricingPage = () => {
  const { t } = useTranslation('landing');
  const status = useAuthStore((state) => state.status);
  const restore = useAuthStore((state) => state.restore);
  const signedIn = status === 'authenticated';
  const [yearly, setYearly] = useState(false);

  useEffect(() => {
    if (status === 'unknown') void restore();
  }, [status, restore]);

  if (status === 'unknown') {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-brand">
        <Spinner className="size-6 text-brand" />
      </div>
    );
  }

  return (
    <LandingMarketingShell signedIn={signedIn}>
      <main className="text-on-brand">
        <section className="landing-section-separator py-12 sm:py-16">
          <div className="mx-auto max-w-6xl px-4 text-center sm:px-6 lg:px-8">
            <LandingReveal>
              <h1 className="landing-display text-balance text-[2rem] font-semibold tracking-tight sm:text-[2.5rem]">
                {t('pricing.title')}
              </h1>
              <p className="mx-auto mt-4 max-w-xl text-pretty text-body leading-relaxed text-on-brand/90 sm:text-card-title">
                {t('pricing.subtitle')}
              </p>
              {!signedIn ? (
                <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                  <Button
                    size="lg"
                    className="w-full min-w-[11.75rem] bg-on-brand text-brand shadow-e2 hover:bg-on-brand/90 active:bg-on-brand/85 sm:w-auto"
                    asChild
                  >
                    <Link to="/register">{t('hero.primaryCta')}</Link>
                  </Button>
                  <Button
                    size="lg"
                    variant="outline"
                    className="landing-free-plans-cta-secondary w-full min-w-[11.75rem] sm:w-auto"
                    asChild
                  >
                    <Link to="/free">{t('pricing.freePlansCta')}</Link>
                  </Button>
                </div>
              ) : null}
            </LandingReveal>
          </div>
        </section>

        <LandingSection
          title={t('pricing.paidPlans.title')}
          subtitle={t('pricing.paidPlans.subtitle')}
          className="py-12 sm:py-16 lg:py-20"
          centered
          onBrand
        >
          <LandingPaidPlans signedIn={signedIn} yearly={yearly} onYearlyChange={setYearly} />
        </LandingSection>
      </main>
    </LandingMarketingShell>
  );
};
